const CloseX = (props) => (
  <svg width='40.047' height='40' viewBox='0 0 40.047 40' fill='#152a46' {...props}>
    <path d='M20.023,0a19.515,19.515,0,0,0-7.784,1.571A20.083,20.083,0,0,0,1.571,12.216,19.348,19.348,0,0,0,0,19.977a19.465,19.465,0,0,0,1.571,7.808A20.083,20.083,0,0,0,12.239,38.429,19.516,19.516,0,0,0,20.023,40a19.516,19.516,0,0,0,7.784-1.571A20.083,20.083,0,0,0,38.476,27.784a19.465,19.465,0,0,0,1.571-7.808,19.348,19.348,0,0,0-1.571-7.761A20.083,20.083,0,0,0,27.808,1.571,19.515,19.515,0,0,0,20.023,0Zm9.332,26.213-3.142,3.142-6.19-6.237-6.19,6.237-3.142-3.142,6.19-6.237-6.19-6.19,3.142-3.142,6.19,6.19,6.19-6.19,3.142,3.142-6.19,6.19Z' />
  </svg>
)

export default CloseX
